import { render, staticRenderFns } from "./ThgBillingCreditorUpdateDialog.vue?vue&type=template&id=44a6860c&"
import script from "./ThgBillingCreditorUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingCreditorUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRow,VTextField})
